import { CourseRequirementType, ICourse, ICreateCourseRequirement } from '@/types/courses';
import { TReactSelectOption } from '@ui/select/react-select/custom-react-select.types';

export const DEFAULT_NEW_REQUIREMENT: ICreateCourseRequirement = {
  type: CourseRequirementType.watched_minute,
  session_id: 0,
  unit_type: 'discrete',
  points: 0,
  settings: {},
  required_amount: 0,
  // Unused below, will be handled in the API but needed for typescript
  course_id: 0,
  channel: 0,
  created_by: 0,
};

// no requirement type carries settings of its own any more - pulse checks were the only one
export const defaultSettings = (): Record<string, never> => {
  return {};
};

export const defaultCategories = (course: ICourse | null): TReactSelectOption<string, string, string>[] => {
  if (!course?.categories) return [];

  return course.categories
    .map((c) => {
      return {
        label: `${c}`.trim(),
        value: c,
        meta: c,
      };
    })
    .filter(Boolean) as TReactSelectOption<string, string, string>[];
};
